export const LEARNING_PATHS_HOME_ROUTE: string = "/learning-paths";
